const closestPolyfill = (): void => {
  if (!Element.prototype.matches) {
    // TS doesn't recognize this obsolete IE property
    Element.prototype.matches = (Element.prototype as any).msMatchesSelector ||
      Element.prototype.webkitMatchesSelector;
  }

  if (!Element.prototype.closest) {
    Element.prototype.closest = function (s: string) {
      /* eslint-disable-next-line @typescript-eslint/no-this-alias */
      let el = this;

      do {
        if (el.matches(s)) { return el; }
        el = el.parentElement || el.parentNode;
      } while (el !== null && el.nodeType === 1);
      return null;
    };
  }
};

export default closestPolyfill;
